import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import { CreateFormData } from "../../../types/forms";
import { TYPE_FORMS } from "../../../utils/constants";
import { Autocomplete } from "../../Autocomplete";

export function Infos() {
  const formik = useFormikContext<CreateFormData>();

  const valueType = useMemo(() => {
    return TYPE_FORMS.find(({ value }) => value === formik.values.typeForm);
  }, [formik.values.typeForm]);

  return (
    <>
      <Typography color="primary" marginBottom={2}>
        Informações
      </Typography>

      <Autocomplete
        size="small"
        label="Tipo"
        options={TYPE_FORMS}
        getOptionLabel={(option) => option.label}
        onChange={(_, type) => formik.setFieldValue("typeForm", type.value)}
        value={valueType}
        helperText={formik.errors.typeForm}
        error={Boolean(formik.errors.typeForm)}
      />
      <TextField
        size="small"
        variant="outlined"
        margin="normal"
        label="Nome"
        value={formik.values.nameForm}
        onChange={({ target: { value } }) =>
          formik.setFieldValue("nameForm", value)
        }
        helperText={formik.errors.nameForm}
        error={Boolean(formik.errors.nameForm)}
      />
    </>
  );
}
